import Meta from "components/Meta"
import { useEffect, useState } from "react"
import { getGlobals } from "storyblok/api"
import { useRouter } from "next/router"
import { useQueryState } from "next-usequerystate"
import Script from "next/script"
import CTABanner from "components/DynamicComponent/atoms/CTABanner"

export default function Page({ meta }) {
  const [query, setQuery] = useQueryState("q", { shallow: true })
  const [search, setSearch] = useState(null)

  useEffect(() => {
    if (search) {
      search.triggerSearch(query)
    }
  }, [search, query, setQuery])

  return (
    <>
      <Meta info={meta} />
      <main className="px-6" data-pagefind-ignore>
        <div className="mx-auto max-w-screen-xl py-16 text-left text-teal-dark">
          <div className="mx-auto max-w-screen-md">
            <div id="search-page"></div>
            <Script
              src="pagefind/pagefind-ui.js"
              onLoad={() => {
                const search = new PagefindUI({
                  element: "#search-page",
                  showImages: false,
                  resetStyles: false,
                  translations: {
                    placeholder: "Search our site",
                    clear_search: "Clear",
                    load_more: "Load more results",
                    search_label: "Search our site",
                    filters_label: "Filters",
                    zero_results: "No results for “[SEARCH_TERM]”",
                    many_results: "[COUNT] results for “[SEARCH_TERM]”",
                    one_result: "[COUNT] result for “[SEARCH_TERM]”",
                    alt_search: "No results for “[SEARCH_TERM]”. Showing results for [DIFFERENT_TERM]” instead",
                    search_suggestion: "No results for “[SEARCH_TERM]”. Try one of the following searches:",
                    searching: "Searching for “[SEARCH_TERM]”...",
                  },
                  processResult: function (result) {
                    return {
                      ...result,
                      // TODO: figure out why some results are included with the wrong URL i.e. /server/pages/
                      url: result.url.replaceAll(/\/server\/pages|.html/gi, ""),
                    }
                  },
                })

                setSearch(search)
              }}
            />
          </div>
        </div>
      </main>
      <CTABanner />
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const globals = await getGlobals()

  return {
    props: {
      preview,
      globals,
    },
  }
}
